import React from "react";
import { Form, InputNumber, Select } from "antd";
import { APARTMENT_DURATION_UNIT_OPTIONS } from "../../../constants";

export default function MainFeaturesSection() {
  return (
    <>
      <Form.Item name="maxAmount" label="Зээлийн хэмжээ (₮)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={(v) => v.replace(/,/g, "")}
          placeholder="150,000,000"
        />
      </Form.Item>

      <Form.Item label="Зээлийн хугацаа">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="durationValue" noStyle>
            <InputNumber style={{ width: "100%" }} min={1} placeholder="30" />
          </Form.Item>
          <Form.Item name="durationUnit" noStyle initialValue="жил">
            <Select
              style={{ width: 100 }}
              options={APARTMENT_DURATION_UNIT_OPTIONS}
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item name="monthlyInterestRate" label="Зээлийн сарын хүү (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.01}
          placeholder="0.5"
        />
      </Form.Item>
    </>
  );
}
